module Visonum.BulkPingApp.CSV
  ( CSV
  , printCsv
  ) where

import Prelude

import Data.Maybe (Maybe(..))
import Data.String as Str
import Data.String.Pattern (Pattern(..), Replacement(..))

type CSV =
  { headers :: Array String
  , rows :: Array (Array (Maybe String))
  }

printCsv :: CSV -> String
printCsv { headers, rows } = head <> body
  where
  head =
    printRow (map Just headers) <> "\n"

  body =
    Str.joinWith "\n" $ map printRow rows

printRow :: Array (Maybe String) -> String
printRow cells = Str.joinWith "," $ map printCell cells

printCell :: Maybe String -> String
printCell = case _ of
  Nothing -> ""
  Just cell ->
    if not hasDoubleTicks cell && not hasCommas cell then
      cell
    else
      "\"" <> Str.replaceAll (Pattern "\"") (Replacement "\"\"") cell <> "\""

hasDoubleTicks :: String -> Boolean
hasDoubleTicks = Str.contains (Pattern "\"")

hasCommas :: String -> Boolean
hasCommas = Str.contains (Pattern ",")